<template>
  <div id="app">
    <div class="content">
      <JsonViewer/>
    </div>
    <div class="footer">
      <div class="donate">
        <h3>项目的发展离不开你的支持，请作者喝杯咖啡吧！</h3>
        <h4>支付时留下邮箱还可以获得本项目前端源码和完整的 k8s api 结构化数据</h4>
        <div style="width: 600px;margin:0 auto;text-align:center;">
          <div style="float: left;"><img src="https://mybatis.io/img/wx_pay.png" width="200"></div>
          <div style="float: right;"><img src="https://mybatis.io/img/ali_pay.png" width="200"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JsonViewer from './components/JsonViewer.vue'

export default {
  name: 'app',
  components: {
    JsonViewer
  }
}

var _hmt = _hmt || [];
(function () {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?d509a6c67b04a5bb16e4a4bdbd512bae";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
</script>

<style scoped>
.content {
  min-height: calc(100vh - 350px);
}
.footer {
  height: 300px;
  margin: 0 auto;
  text-align: center;
  line-height: 0.5em;
}
</style>
